import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import globeIcon from '../../assets/icons/globe-icon.jpg'
import mangroveSingleIcon from '../../assets/icons/mangrove-single.png'
import mangroveMultiplecon from '../../assets/icons/mangrove-multiple.png'
import habitatIcon from '../../assets/icons/habitat-icon.jpg'

function Pricing() {
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Dashboard Pricing Page' });
  }, []);
  const dataArr = [
    {
      icon: mangroveSingleIcon,
      title: 'plant a mangrove tree',
      description: 'this includes planting and long-term care to foster the tree toward healthy growth',
      price: '$2'
    },
    {
      icon: habitatIcon,
      title: 'balance a habitat',
      description: 'supplement the planting with other regionally-specific fauna to optimize recovery and animal reintroduction',
      price: '$500'
    },
    {
      icon: mangroveMultiplecon,
      title: 'plant 10 mangrove trees',
      description: 'this is a nice introductory package to support our global initiatives',
      price: '$20'
    },
    {
      icon: globeIcon,
      title: 'restore a location ecosystem',
      description: 'this takes years of repeated care and supervision, managing plant and animal growth and health',
      price: '$10,000'
    },
  ]
  return (
    <>
    <div className="layout-wrapper layout-content-navbar">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Pricing</title>
      </Helmet>
      <div className="layout-container">
        <div>
          <div style={{textAlign: 'left', padding: '8rem 5rem 1rem 2rem'}}>
            <strong style={{color: '#015a92'}}>What does it cost to transform an ecosystem?</strong>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', padding: '0rem 5rem 5rem 0rem' }}>
            {
              dataArr.map(({ title, price, description, icon }, index) => {
                return (
                  <div style={{padding: '2rem', display: 'flex'}}>
                    <div style={{display: 'flex', paddingRight: '1rem'}}>
                      <img src={icon} style={{height: index === 3 ? '4.3rem' : '5rem'}} />
                    </div>
                    <div>
                      <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <strong style={{color: '#015a92'}}>{title}</strong>
                        <span style={{color: '#015a92'}}>{price}</span>
                      </div>
                      <div><p style={{color: '#015a92', fontStyle: 'oblique', fontSize: '0.8rem'}}>{description}</p></div>
                    </div>
                  </div>
                );
              })
            }
        </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Pricing;